import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Bell, BellRing, CheckCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { EmptyState } from "@/components/EmptyState";

export default function Notificacoes() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/notifications/me").then(r => setItems(r.data || [])).catch(() => {}); }, []);
  const markRead = async (id) => {
    try {
      await api.post(`/notifications/${id}/read`);
      setItems(prev => prev.map(n => n.id === id ? { ...n, read: true } : n));
    } catch {}
  };
  return (
    <div className="space-y-3" data-testid="notificacoes-page">
      <h1 className="font-display font-semibold text-xl text-[hsl(var(--primary))]">Notificações</h1>
      {items.length === 0 ? <EmptyState icon={Bell} title="Sem notificações por enquanto" description="Você será avisado(a) sobre novos cursos, certificados e benefícios." />
        : items.map(n => (
          <Card key={n.id} className={`rounded-xl ${!n.read ? "border-[hsl(var(--accent)/0.4)]" : ""}`} onClick={() => !n.read && markRead(n.id)} data-testid={`notification-${n.id}`}>
            <CardContent className="p-4 flex gap-3">
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${!n.read ? "bg-[hsl(var(--accent)/0.1)] text-[hsl(var(--accent))]" : "bg-[hsl(var(--secondary))] text-muted-foreground"}`}>
                {n.read ? <CheckCheck className="w-5 h-5" /> : <BellRing className="w-5 h-5" />}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-display font-medium text-[hsl(var(--primary))]">{n.title}</h3>
                  {!n.read && <Badge className="bg-[hsl(var(--accent))] text-white">Nova</Badge>}
                </div>
                <p className="text-sm text-muted-foreground mt-0.5">{n.body}</p>
                <p className="text-[11px] text-muted-foreground mt-1">{n.created_at && new Date(n.created_at).toLocaleString("pt-BR")}</p>
              </div>
            </CardContent>
          </Card>
        ))}
    </div>
  );
}
